// src/app/auth/UserContext.tsx
import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { getUserProfile } from './authService';
import apiFetch from "@/app/auth/apiFetch.tsx";
import {useNavigate} from "react-router-dom";

// Interface pour les données utilisateur
export interface User {
    id?: string;
    name: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: string;
    roles?: string[];
}

interface UserContextType {
    user: User | null;
    loading: boolean;
    error: string | null;
    refreshUserProfile: () => Promise<void>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

const apiUrl = import.meta.env.VITE_API_URL;

export function UserProvider({ children }: { children: ReactNode }) {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate()

    const loadUserProfile = async () => {
        try {
            setLoading(true);
            setError(null);
            const profile = await getUserProfile();
            setUser(profile || null);
        } catch (err) {
            console.error('Erreur lors du chargement du profil:', err);
            setError(err instanceof Error ? err.message : 'Erreur inconnue');
        } finally {
            setLoading(false);
        }
    };

    // Fonction pour rafraîchir le profil utilisateur
    const refreshUserProfile = async () => {
        try {
            setLoading(true);
            const response = await apiFetch(`${apiUrl}/account/`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                },
            }, navigate);

            if (response.ok) {
                const userData = await response.json();
                setUser(userData);
            }
        } catch (error) {
            console.error("Erreur lors du rafraîchissement du profil:", error);
        } finally {
            setLoading(false);
        }
    };


    // Charger le profil au montage du composant
    useEffect(() => {
        loadUserProfile();
    }, []);

    return (
        <UserContext.Provider value={{ user, loading, error, refreshUserProfile }}>
            {children}
        </UserContext.Provider>
    );
}
